// Sandbox environment for the isolated compose stack — SCC / LOF Vet brand.
//
// Identical to environment.sandbox.ts (same-origin endpoints resolved from
// window.location) but with mode 'scc': the app renders the LOF Vet branding
// and logs in with origin SCC (requires a Veterinary/InvitedVet/SccVeterinary
// role on the account). Built by scripts/build-sandbox-images.sh with
// FRONT_MODE=scc; the image is tagged front-scc.
import type { Environment } from './environment.interface';

const origin = window.location.origin;
const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

// serviceWorker is NOT in the app's Environment interface (app-side
// optional feature) — the intersection type keeps Daniel's SW gate
// (app.module: registration requires === true) without TS2353.
export const environment: Environment & { serviceWorker: boolean } = {
  name: 'sandbox-scc',
  production: false,
  mock: false,
  apiUrl: `${origin}/api`,
  orthancUrl: `${origin}/pacs`,
  ohifUrl: `${origin}/ohif`,
  orthancLocalPort: 8082,
  apiWsUrl: `${wsProtocol}://${window.location.host}/api/graphql`,
  displayedStudiesCount: 12,
  pingInterval: 60000,
  studyUploadingRefreshInterval: 30000,
  mode: 'scc',
  allowSccUpload: true,
  zendeskKey: '',
  // Static-asset caching via the Angular service worker (see environment.sandbox.ts
  // for the secure-origin requirement and the mandatory serviceWorker: true —
  // app.module gates registration on `=== true`).
  serviceWorker: true,
};
